var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2_00000023241735694204942690000009362405483975617154_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 78.4",
    style: {
      enableBackground: "new 0 0 128 78.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.4;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#828282;}\n\t.st3{fill:#D8D8D8;}\n\t.st4{fill:#47576F;}\n\t.st5{fill:#602A88;}\n\t.st6{fill:#FFCA55;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.1,70.1c0.2,2.7,2.1,4.7,4.2,4.6l72.7-5.5c2.1-0.2,3.7-2.5,3.5-5.1l-3.4-44.2l-80.4,6.1 C27.8,25.9,31.1,70.1,31.1,70.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.1,69.3c-10.7,0.8-21.9,2.2-32.5,3.6c-12.8,1.6-25.8,2.7-38.7,3.2l-1,0.1c-2.1,0.3-4.5-1.3-5.3-3.9 c-0.4-0.9-0.4-1.9-0.5-2.9c-0.3-6.3-0.9-16.7-1.3-23c-0.7-10.1-0.8-10-1.7-20.1l-0.2-2.5c-0.1-1,0-2,0.3-3 c0.6-1.9,2.1-3.2,3.8-3.4c2.8-0.3,9.5-1,12.2-1.3c11-1.2,25.4-2.4,36.6-3.4c6.7-0.6,13.6-1.1,20.4-1.6l2-0.1l1-0.1 c1.2-0.2,3,0.3,4,1.4c1.3,1.2,2.2,3.1,2.3,5c0,0.1,0.1,0.8,0.1,1c1,14.5,0.6,18.5,1.4,33c0.2,3.4,0.4,6.8,0.6,10.2l0.2,2.6 C112,66.6,110.3,69.2,108.1,69.3L108.1,69.3L108.1,69.3z M108,68.9c2-0.1,3.6-2.5,3.3-5l-0.2-2.6c-0.9-10.2-2.1-20.4-3.2-30.6 c-0.8-7.5-0.8-4.9-1.5-12.4l-0.1-0.6c0-0.1,0-0.2,0-0.3c-0.1-1.3-1.1-2.4-2.1-2.5c-7.9,0.6-16.2,1.3-24.2,1.8 c-11.3,0.8-25.6,1.7-36.7,2.2c-2.7,0.1-9.5,0.4-12.2,0.5c-1,0-2.1,0.8-2.5,2c-0.2,0.6-0.4,1.3-0.3,2l0.1,2.6 c0.8,13.4,1,17,2.3,30.3c0.2,1.8,1.1,11.1,1.3,12.7l0.1,0.6c0,0.1,0,0.2,0,0.3c0.2,1.6,1.4,3.1,2.7,3.1c0.3,0,0.5,0,0.8,0l1-0.1 l2-0.2C61.6,69.9,85,70.6,108,68.9L108,68.9L108,68.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.9,12.8l-72.7,5.5c-2.1,0.2-3.7,2.5-3.5,5.1l0.4,4.8l80.4-6.1l-0.4-4.8C107.9,14.7,106,12.6,103.9,12.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M40.2,13.6l1-0.1c0.8-0.1,1.5,0.6,1.6,1.4l0.5,6.6c0.1,0.8-0.6,1.5-1.4,1.6l-1,0.1c-0.8,0.1-1.5-0.6-1.6-1.4 l-0.5-6.6C38.8,14.4,39.4,13.7,40.2,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.4,13.4l1-0.1c0.8-0.1,1.5,0.6,1.6,1.4l0.5,6.6c0.1,0.8-0.6,1.5-1.4,1.6l-1,0.1c-0.8,0.1-1.5-0.6-1.6-1.4 L39,15C38.9,14.2,39.6,13.4,40.4,13.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M93.6,9.5l1-0.1c0.8-0.1,1.5,0.6,1.6,1.4l0.5,6.6c0.1,0.8-0.6,1.5-1.4,1.6l-1,0.1c-0.8,0.1-1.5-0.6-1.6-1.4 l-0.5-6.6C92.2,10.3,92.8,9.6,93.6,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.8,9.3l1-0.1c0.8-0.1,1.5,0.6,1.6,1.4l0.5,6.6c0.1,0.8-0.6,1.5-1.4,1.6l-1,0.1c-0.8,0.1-1.5-0.6-1.6-1.4 l-0.5-6.6C92.3,10.1,93,9.4,93.8,9.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M34.5,33.4c8.4-1,16.8-1.6,25.3-2c14-1.2,28.1-2.7,42.2-3.1v0.1c-14,1.7-28.1,2.3-42.1,3.3 C51.5,32.4,42.8,33.4,34.5,33.4L34.5,33.4L34.5,33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M35.4,44.1c8.4-1.1,16.8-1.6,25.3-2c14-1.2,28.1-2.7,42.2-3.1V39c-14,1.7-28.1,2.3-42.1,3.3 C52.3,43.1,43.7,44.1,35.4,44.1L35.4,44.1L35.4,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M36.2,54.8c8.4-1.1,16.8-1.6,25.3-2c14.1-1.2,28.1-2.7,42.2-3.1v0.1c-14,1.7-28.1,2.3-42.1,3.3 C53.1,53.7,44.5,54.7,36.2,54.8L36.2,54.8L36.2,54.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M37,65.4c8.4-1.1,16.8-1.6,25.3-2c14.1-1.2,28.1-2.7,42.2-3.1v0.1c-14,1.7-28.1,2.3-42.1,3.3 C53.9,64.4,45.3,65.4,37,65.4L37,65.4L37,65.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M37,65.5c-0.7-4-0.9-8-1-12c-0.5-6.6-1.7-13.5-1.4-20c1.2,6.6,1.2,13.3,1.6,20C36.7,57.4,37.3,61.6,37,65.5 L37,65.5L37,65.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M59.5,63.8c-0.7-4-0.9-8-1-12c-0.5-6.6-1.7-13.5-1.4-20c1.2,6.6,1.2,13.3,1.6,20 C59.1,55.7,59.8,59.9,59.5,63.8L59.5,63.8L59.5,63.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M70.7,62.9c-0.7-4-0.9-8-1-12c-0.5-6.6-1.7-13.5-1.4-20c1.2,6.6,1.2,13.3,1.6,20C70.4,54.8,71,59,70.7,62.9 L70.7,62.9L70.7,62.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M93.2,61.2c-0.7-4-0.9-8-1-12c-0.5-6.6-1.7-13.5-1.4-20c1.2,6.6,1.2,13.3,1.6,20 C92.9,53.1,93.5,57.3,93.2,61.2L93.2,61.2L93.2,61.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M48.2,64.6c-0.7-4-0.9-8-1-12c-0.5-6.6-1.7-13.5-1.4-20c1.2,6.6,1.2,13.3,1.6,20 C47.9,56.5,48.5,60.8,48.2,64.6L48.2,64.6L48.2,64.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M81.9,62.1c-0.7-4-0.9-8-1-12c-0.5-6.6-1.7-13.5-1.4-20c1.2,6.6,1.2,13.3,1.6,20 C81.6,54,82.2,58.2,81.9,62.1L81.9,62.1L81.9,62.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.4,60.3c-0.7-4-0.9-8-1-12c-0.5-6.6-1.7-13.5-1.4-20c1.2,6.6,1.2,13.3,1.6,20 C104.1,52.2,104.7,56.5,104.4,60.3L104.4,60.3L104.4,60.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M25.8,23.1c0.8,5.1-5.6,5.8-6.9,1.2C18,19.5,25,18.1,25.8,23.1L25.8,23.1z M25.8,23.1 c-0.9-3.8-6.8-2.8-6.4,1.1C19.8,28.5,26.3,27,25.8,23.1L25.8,23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M18.8,32.1c2.6,1.6,0.3,4.8-2.2,3.6C14,34.2,16.2,30.5,18.8,32.1L18.8,32.1z M18.8,32.2c-2-1.1-3.9,1.9-2,3.3 C18.8,37,20.7,33.4,18.8,32.2L18.8,32.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M30.8,32.1c2.6,1.6,0.3,4.8-2.2,3.6C26.1,34.2,28.2,30.4,30.8,32.1L30.8,32.1z M30.8,32.1c-2-1.1-4,1.9-2,3.3 C30.8,36.9,32.7,33.4,30.8,32.1L30.8,32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M105.8,6.8c0.2,1.3,0.4,2.7,0,4c-0.1,0.4-0.4,0.9-0.9,1.1c-0.6,0-0.9-0.4-1.2-0.7c-1.2-1.6-2.8-7.8-0.5-8.9 c0.6-0.1,1,0.4,1.2,0.7C105.3,4.1,105.6,5.5,105.8,6.8C105.8,6.8,105.8,6.8,105.8,6.8z M105.8,6.8c-0.1-1.2-2.1-6.3-3.2-3.4 c-0.7,1.9-0.1,7.8,2.3,8.2c0.4-0.1,0.6-0.5,0.7-0.9C106,9.5,106,8.1,105.8,6.8L105.8,6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M112.1,13c0.2,1.3,0.4,2.7,0,4c-0.1,0.4-0.4,0.9-0.9,1.1c-0.6,0-0.9-0.4-1.2-0.7c-1.2-1.6-2.8-7.8-0.5-8.9 c0.6-0.1,1,0.4,1.2,0.7C111.6,10.3,111.9,11.7,112.1,13C112.1,13,112.1,13,112.1,13z M112.1,13c-0.1-1.2-2.1-6.3-3.2-3.3 c-0.7,1.9-0.1,7.8,2.3,8.2c0.4-0.1,0.6-0.5,0.7-0.9C112.3,15.6,112.3,14.3,112.1,13C112.1,13,112.1,13,112.1,13z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9847 -0.1742 0.1742 0.9847 -9.1769 19.9235)",
    className: "st5",
    cx: 108.9,
    cy: 62.3,
    rx: 1.1,
    ry: 3.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9847 -0.1742 0.1742 0.9847 -9.1769 19.9235)",
    className: "st5",
    cx: 108.9,
    cy: 62.3,
    rx: 3.4,
    ry: 0.9
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "39.7,63.6 43,57.2 46.4,50.8 50.3,56.9 54.1,63 46.9,63.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 70.4,
    cy: 42.5,
    r: 26.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M72.2,16.1C95.8,17.7,105.7,47,88,62.6c-10.6,9.7-28.4,8.5-37.7-2.5C34.7,42.2,48.6,14.4,72.2,16.1 C72.2,16.1,72.2,16.1,72.2,16.1z M72.2,16.1c-23.3-1.4-36.8,26.1-21.6,43.7c9.1,10.8,26.6,12,37.1,2.6 C105.4,46.9,95.6,17.8,72.2,16.1L72.2,16.1L72.2,16.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderCalendar);
export default __webpack_public_path__ + "static/media/header_calendar.208e053cba573bcf492c8d143f40a8c6.svg";
export { ForwardRef as ReactComponent };